import { FetchSearchClient } from "services/searchClient";
import { useQuery } from "react-query";
import ApiResult from "utils/api/models/api-result";
import { ApiError } from "utils/api/models/api-error";
import useDebounce from "hooks/others/useDebounce";
import { SearchClientResponse } from "models/searchClient";

export default function useSearchClient(SearchText: string) {
  const { newParam: searchParam } = useDebounce(SearchText);

  return useQuery<ApiResult<SearchClientResponse>, ApiError>(
    ["clients", searchParam],
    () => FetchSearchClient(searchParam),
    {
      keepPreviousData: true,
      enabled: !!searchParam,
    }
  );
}
